import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { FormBuilder, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { StudentService } from '../../../../../../services/students/student.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';

import { MY_FORMATS } from '../../../../../../const/date-format';

import { Observable } from 'rxjs/Observable';
import { HistoryStudent } from '../../../../../../models/students/dto/HistoryStudentDto';

@Component({
    selector: 'fuse-history-student',
    templateUrl: './history-student.component.html',
    styleUrls: ['./history-student.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    animations: fuseAnimations
})
export class HistoryStudentComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    studentFormGroup;
    tutorFormGroup;

    courseFormControl;
    studentDocNumberFormControl;
    studentLastNameFormControl;
    studentFirstNameFormControl;

    markerLngX: number = null;
    markerLatY: number = null;
    confirmDialogRef: any;
    public baseUri;

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();
    docNumberEntry: String;

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerTutorBirthdate;
    maskedInputControllerStudentBirthdate;

    historyStudent: HistoryStudent[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<HistoryStudentComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private studentService: StudentService,
        private fb: FormBuilder,
        public dialog: MatDialog,
    ) {
        console.log('HistoryStudentComponent*** > data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        if (this.data.mode === 'view') {
            this.disable();
        }

        this.docNumberEntry = this.data.docNumber;
        this.searchStudent(this.docNumberEntry);
    }

    searchStudent(docNumber) {
        const observables = [];
        observables.push(this.studentService.getHistoryByStudent(this.docNumberEntry));
        Observable.combineLatest(
            observables
        ).subscribe((result) => {
            console.log('result', result);
            this.blockUI.stop();
            this.historyStudent = result[0];
            console.log(this.historyStudent);
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    disable() {
        this.studentFormGroup.get('courseFormControl').disable();
        this.studentFormGroup.get('studentDocNumberFormControl').disable();
        this.studentFormGroup.get('studentLastNameFormControl').disable();
        this.studentFormGroup.get('studentFirstNameFormControl').disable();
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {

    }

    initializeFormControlValidators() {
        this.studentFormGroup = this.fb.group({
            courseFormControl: ['', [Validators.required]],
            studentDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            studentLastNameFormControl: ['', [Validators.required]],
            studentFirstNameFormControl: ['', [Validators.required]],
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    setMarker($event: any) {
        // console.log('FuseAddStoreComponent > setMarker > $event', $event);
        this.markerLngX = $event.coords.lng;
        this.markerLatY = $event.coords.lat;
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/history/history-student.component.ts